import { render, staticRenderFns } from "./email_addresses_editor.vue?vue&type=template&id=4503e5a0&scoped=true&"
import script from "./email_addresses_editor.vue?vue&type=script&lang=js&"
export * from "./email_addresses_editor.vue?vue&type=script&lang=js&"
import style0 from "./email_addresses_editor.vue?vue&type=style&index=0&id=4503e5a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503e5a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4503e5a0')) {
      api.createRecord('4503e5a0', component.options)
    } else {
      api.reload('4503e5a0', component.options)
    }
    module.hot.accept("./email_addresses_editor.vue?vue&type=template&id=4503e5a0&scoped=true&", function () {
      api.rerender('4503e5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/email_addresses_editor.vue"
export default component.exports